<div class="card">
  <div class="card-header">{{ "general.data" | translate }}</div>
  <div class="card-body">
    <app-profile-edit [formGroup]="formGroupInput()" />
  </div>
</div>
